import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { MSingleBodyContainerComponent } from './single-body-container.component';

@NgModule({
  declarations: [MSingleBodyContainerComponent],
  exports: [MSingleBodyContainerComponent],
  imports: [CommonModule, NzCardModule, NzIconModule, NzToolTipModule]
})
export class MSingleBodyContainerModule {}
